module.exports = __webpack_public_path__ + "img/resources-1440.20a964a3.jpg";